import styled from 'styled-components'
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined'
import { BigNumberKPIList, Card } from '../../components'
import PredictionDashboard from '../../pages/Dashboard/PredictionDashboard'
import OptimizedDashboard from '../../pages/Dashboard/OptimizedDashboard'
import useDashboard from '../../hooks/useDashboard'
import { useEffect } from 'react'
import useEmployeeKPIs from '../../hooks/useEmployeeKPIs'
import useViewport from '../../hooks/useViewport'
import { PLANS } from '../../utils/planNames'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;

  > span {
    margin-bottom: 24px;
  }
`

const GraphicsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
`

const KPIsContainer = styled.div`
  display: flex;
  margin-top: 24px;

  > div {
    display: flex;
    flex-direction: ${({ screenWidth, plan }) => {
    if (plan === PLANS.NOW) return 'row'

    return screenWidth <= 1160 ? 'row' : 'column'
  }};
  }
`

const GraphicsKPIsContainer = styled.div`
  display: flex;
  flex-direction: ${({ screenWidth }) =>
    screenWidth <= 1160 ? 'column' : 'row'};
  gap: ${({ screenWidth }) => (screenWidth <= 1160 ? '0' : '24')}px;
`

const EmployeeActionArea = ({ selectedEmployee, setLink, openModal }) => {
  const { data, dashboardPlan, fetchData, loading } = useDashboard()
  const {
    loading: loadingKPIs,
    data: kpis,
    fetchData: fetchEmployeeKPIs,
  } = useEmployeeKPIs()
  const { width } = useViewport()
  const { t } = useTranslation('common')

  useEffect(() => {
    if (!loading) {
      fetchData({ employeeId: selectedEmployee.id })
    }

    if (!loadingKPIs) {
      fetchEmployeeKPIs({ employeeId: selectedEmployee.id })
    }
  }, [selectedEmployee.id])

  useEffect(() => {
    if (!loading) {
      window.scrollTo({
        left: 0,
        top: document.body.scrollHeight,
        behavior: 'smooth',
      })
    }
  }, [selectedEmployee.id, dashboardPlan])

  return (
    <Container>
      <ActionContainer>
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          {t('information_for')} {selectedEmployee.name}
        </span>
        <Card
          image={<CreateOutlinedIcon />}
          description={t('add_notification_annotation')}
          onClick={() => {
            setLink(`user-list?user_ids=${selectedEmployee.id}`)
            openModal()
          }}
        />
      </ActionContainer>
      {!dashboardPlan ? (
        <span>Carregando</span>
      ) : (
        <GraphicsKPIsContainer screenWidth={width}>
          {dashboardPlan === PLANS.PREDICTION && (
            <GraphicsContainer>
              <span style={{ fontSize: 20, fontWeight: 600 }}>
                {t('alert_index')}
              </span>
              <PredictionDashboard
                predictionResult={data?.predictionData}
                userShifts={data?.userShifts}
                sleepTime={data?.sleepTime}
                ingestedCaffeine={data?.ingestedCaffeine}
                bacLevels={data?.bacLevels}
              />
            </GraphicsContainer>
          )}
          {dashboardPlan === PLANS.OPTIMIZED && (
            <GraphicsContainer>
              <span style={{ fontSize: 20, fontWeight: 600 }}>
                {t('alert_index')}
              </span>
              <OptimizedDashboard
                recommendations={data?.recommendations}
                predictionResult={data?.predictionData}
                optimizeResult={data?.optimizeData}
                userShifts={data?.userShifts}
                sleepTime={data?.sleepTime}
                ingestedCaffeine={data?.ingestedCaffeine}
                bacLevels={data?.bacLevels}
              />
            </GraphicsContainer>
          )}
          {!loadingKPIs && (
            <KPIsContainer
              screenWidth={width}
              plan={dashboardPlan}
            >
              <BigNumberKPIList kpis={kpis} />
            </KPIsContainer>
          )}
        </GraphicsKPIsContainer>
      )}
    </Container>
  )
}

export default EmployeeActionArea
